import { YouTubeDebugPage } from "@/components/debugging/youtube-debug-pages";

export default function DebugEmbeddedYouTubeStep03Page() {
  return <YouTubeDebugPage stepNumber="03" />;
}
